import React from 'react';


import { CSSTransition, SwitchTransition} from 'react-transition-group';
import { range } from 'lodash-es';

import { v4 as uuidv4 } from 'uuid';

import { history } from '../history'

import Helmet from "./common/Helmet";
import MembershipFeatureDescription from './common/MembershipFeatureDescription'

import {
  REQUEST_FETCHING,
  REQUEST_UNSTARTED,
  REQUEST_ERROR,
  REQUEST_SUCCESS,
} from '../constants/requestStates'

import {
  nervousSystemStates,
} from '../constants/nervousSystemStates'

import {
  REQ_SAVE_QUIZ_RESULTS,
} from '../constants/requestTypes'

import {
  NeuroFitNamedLogoLinkSvg,
  NeuroFitNamedLogoSvg,
} from '../constants/svgs'

import {
  subdomainUrls,
  ProductionQuizBaseUrl,
  joinWithAnd,
  getTimeOfDay,
  getMetaForDysregulationQuizScore,
  getMetaForQuizSymptomResultsData,
  getMetaForQuizHabitResultsData,
  getMetaForQuizSelfCheckInResultsData,
  getCoachUuidFromQueryString,
  recordFunnelEventGA,
  recordFunnelEventResultGA,
  NeuroFitUniversalAppStoreLink,
  DEFAULT_QUIZ_SESSION_ID_LENGTH,
  MinDesktopWidthPixels,
} from '../utils'

import {
  GA_LABEL_QUIZ_OPENED_PAGE,
  GA_LABEL_QUIZ_COMPLETED_ONBOARDING_SCREEN,
  GA_LABEL_QUIZ_COMPLETED_DIGESTIVE_ISSUES_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_PERSISTENT_PAIN_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_FREQUENT_SICKNESS_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_FREQUENT_IMMUNE_ISSUES_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_BRAIN_FOG_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_FREQUENT_FATIGUE_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_DIFFICULTY_RELAXING_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_DIFFICULTY_CONTROLLING_EMOTIONS_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_FREQUENT_ANXIETY_STRESS_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_FREQUENTLY_IRRITABLE_ON_EDGE_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_EXERCISE_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_PLAY_CREATIVITY_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_STILLNESS_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_BEDTIME_ROUTINE_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_AVOID_LATE_NIGHT_EATING_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_AVOID_ALCOHOL_SUBSTANCES_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_AVOID_STRESSFUL_ONLINE_CONTENT_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_AVOID_SOCIAL_FATIGUE_CHECKBOX,
  GA_LABEL_QUIZ_COMPLETED_RATE_SLEEP_QUALITY_SLIDER,
  GA_LABEL_QUIZ_COMPLETED_RATE_DIET_QUALITY_SLIDER,
  GA_LABEL_QUIZ_COMPLETED_RATE_WATER_INTAKE_QUALITY_SLIDER,
  GA_LABEL_QUIZ_COMPLETED_RATE_OVERALL_PEACE_QUALITY_SLIDER,
  GA_LABEL_QUIZ_COMPLETED_CURRENT_STATE_SCREEN,
  GA_LABEL_QUIZ_COMPLETED_LOVE_AND_RELATIONSHIP_SCREEN,
  GA_LABEL_QUIZ_COMPLETED_MONEY_AND_FINANCE_SCREEN,
  GA_LABEL_QUIZ_COMPLETED_FAMILY_AND_FRIENDS_SCREEN,
  GA_LABEL_QUIZ_COMPLETED_CAREER_AND_BUSINESS_SCREEN,
  GA_LABEL_QUIZ_COMPLETED_HEALTH_AND_WELL_BEING_SCREEN,
  GA_LABEL_QUIZ_COMPLETED_PURPOSE_AND_MISSION_SCREEN,
  GA_LABEL_QUIZ_COMPLETED_ENVIRONMENT_SCREEN,
  GA_LABEL_QUIZ_ENTERED_FIRST_NAME,
  GA_LABEL_QUIZ_ENTERED_EMAIL_ADDRESS,
  GA_LABEL_QUIZ_TRIGGERED_SAVE_RESULTS,
  GA_LABEL_QUIZ_RESULTS,
  GA_LABEL_QUIZ_CLICKED_DOWNLOAD_APP_BUTTON,
} from '../constants/gaEventLabels'

import SendRequestButton from './common/SendRequestButton'
import NeuroFitRing from './common/NeuroFitRing'
import RadioSection from './common/RadioSection'
import SliderSection from './common/SliderSection'
import RadioOptions from './common/RadioOptions'
import DysregulationQuizResults from './common/DysregulationQuizResults'

const QuizResultsIndex = 16

const containerStyle = {textAlign: "start", height: "100%", width: "100vw", overflowX: "hidden", overflowY: "scroll"}

const defaultState = {
  scrollView: {
    // currentIndex: QuizResultsIndex,
    currentIndex: 0,
    slideClassAnimation: "next-story-slide-animation"
  },
  quizResults: {
    symptoms: {
      digestive_problems: null,
      persistent_pain: null,
      frequent_sickness: null,
      frequent_immune_issues: null,
      brain_fog: null,
      frequent_fatigue: null,
      difficulty_relaxing: null,
      difficulty_controlling_emotions: null,
      frequent_anxiety_stress: null,
      frequently_irritable_on_edge: null
    },
    daily_habits: {
      exercise_10_min: null,
      play_creativity_10_min: null,
      stillness_10_min: null,
      bedtime_routine: null,
      avoided_late_night_eating: null,
      avoided_alcohol_and_substances: null,
      avoided_stressful_online_content: null,
      avoided_social_fatigue: null,
      sleep: null,
      diet: null,
      water: null,
      peace: null
    },
    self: {
      current_mood: null
    },
    life_aspects: {
      love_and_relationship: null,
      money_and_finance: null,
      family_and_friends: null,
      career_and_business: null,
      health_and_well_being: null,
      purpose_and_mission: null,
      environment: null
    },
    contact_details: {
      first_name: null,
      email_address: null
    }
  }
}



class DysregulationQuizPage extends React.Component {
  constructor(props){
    super(props)
    let initialState = {...defaultState}

    const coach_uuid = getCoachUuidFromQueryString()

    if (!!coach_uuid) {
      const session_uuid = uuidv4()
      initialState.quizResults.coach_session_details = {
        coach_uuid,
        session_uuid,
      }
    }

    this.state = initialState
  }

  logQuizResult(quizInputs, quizResults) {
    let quizResultObject = {}

    const quizFieldInputPrefix = "quiz_input"
    const quizFieldResultPrefix = "quiz_result"

    // Handle Quiz Inputs.
    Object.keys(quizInputs.symptoms).map(symptomName => {quizResultObject[`${quizFieldInputPrefix}_symptom_${symptomName}`] = quizInputs.symptoms[symptomName]})
    Object.keys(quizInputs.daily_habits).map(habitName => {quizResultObject[`${quizFieldInputPrefix}_habit_${habitName}`] = quizInputs.daily_habits[habitName]})
    quizResultObject[`${quizFieldInputPrefix}_current_mood`] = quizInputs.self.current_mood
    Object.keys(quizInputs.life_aspects).map(lifeAspectName => {quizResultObject[`${quizFieldInputPrefix}_life_aspect_${lifeAspectName}`] = quizInputs.life_aspects[lifeAspectName]})

    // Handle Quiz Results
    quizResultObject[`${quizFieldResultPrefix}_overall`] = quizResults.overall
    Object.keys(quizResults.symptoms).map(symptomName => {quizResultObject[`${quizFieldResultPrefix}_symptom_result_${symptomName}`] = quizResults.symptoms[symptomName]})
    Object.keys(quizResults.habits).map(habitName => {quizResultObject[`${quizFieldResultPrefix}_habit_result_${habitName}`] = quizResults.habits[habitName]})
    quizResultObject[`${quizFieldResultPrefix}_self_check_in_total`] = quizResults.life_aspects.total
    Object.keys(quizResults.life_aspects.breakdown).map(moodName => {quizResultObject[`${quizFieldResultPrefix}_self_check_in_state_${moodName}`] = quizResults.life_aspects.breakdown[moodName]})
    recordFunnelEventResultGA(GA_LABEL_QUIZ_RESULTS, quizResultObject)
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.createQuizResultState !== REQUEST_SUCCESS) && (this.props.createQuizResultState === REQUEST_SUCCESS)) {
      const quizInputs = this.state.quizResults
      const savedQuizResult = this.props.createQuizResult.score
      this.logQuizResult(quizInputs, savedQuizResult)
      this.setState({...this.state, scrollView: {...this.state.scrollView, slideClassAnimation: "next-story-slide-animation"}})
      setTimeout(() => {
        this.setState({...this.state, scrollView: {...this.state.scrollView, currentIndex: QuizResultsIndex}})
      }, 1000)
    }
  }

  componentDidMount() {
    recordFunnelEventGA(GA_LABEL_QUIZ_OPENED_PAGE)
  }

  render() {

    const {safeAreaInsets, innerHeight, innerWidth, isIOSDevice, isAndroidDevice, createQuizResult, createQuizResultState, onCreateQuizResults} = this.props

    const {quizResults, scrollView} = this.state

    const isCoachingLink = !!(quizResults.coach_session_details)

    const {currentIndex, slideClassAnimation} = scrollView

    const timeOfDay = getTimeOfDay()

    let formFieldsCompleted = 0
    let keys = Object.keys(quizResults)

    for (let i = 0; i < keys.length; i++) {
      if (keys[i] !== "coach_session_details") {
        const obj = quizResults[keys[i]]

        const leaves = Object.keys(obj)
        for (let j = 0; j < leaves.length; j++) {
          if (obj[leaves[j]] !== null) {
            formFieldsCompleted += 1
          }
        }
      }
    }


    const formFieldCount = Object.keys(quizResults.symptoms).length + Object.keys(quizResults.self).length + Object.keys(quizResults.life_aspects).length + Object.keys(quizResults.daily_habits).length + Object.keys(quizResults.contact_details).length
    const completionPct = (formFieldsCompleted * 1.0) / (formFieldCount * 1.0)

    const formIsComplete = (completionPct === 1.0)

    const saveResultsButtonText = (createQuizResultState === REQUEST_UNSTARTED || createQuizResultState === REQUEST_ERROR) ? "SAVE & VIEW RESULTS" : ((createQuizResultState === REQUEST_FETCHING) ? "SAVING..." : "SAVED RESPONSES.")

    const formFieldsDisabled = ((createQuizResultState === REQUEST_FETCHING) || (createQuizResultState === REQUEST_SUCCESS))

    const saveButtonEnabled = formIsComplete && !!(quizResults.contact_details.first_name) && !!(quizResults.contact_details.email_address) && ((createQuizResultState === REQUEST_UNSTARTED) || (createQuizResultState === REQUEST_ERROR))
    
    const backButtonDisabled = (formFieldsDisabled || currentIndex === 0)

    const onboardingIndex =  0
    const physicalSymptomsIndex = 1
    const mentalSymptomsIndex = 2
    const emotionalSymptomsIndex = 3
    const activityCheckBoxIndex = 4
    const activityCheckBox2Index = 5
    const habitRatingIndex = 6
    const currentStateIndex = 7
    const loveRelationshipIndex = 8
    const moneyFinanceIndex = 9
    const familyFriendsIndex = 10
    const careerBusinessIndex = 11
    const healthWellBeingIndex = 12
    const purposeMissionIndex = 13
    const environmentIndex = 14
    const saveResultsIndex = 15

    const backgroundColorMap = {
      [onboardingIndex]: "#EDEEF2",
      [physicalSymptomsIndex]: "#EDEEF2",
      [mentalSymptomsIndex]: "#EDEEF2",
      [emotionalSymptomsIndex]: "#EDEEF2",
      [activityCheckBoxIndex]: "#EDEEF2",
      [activityCheckBox2Index]: "#EDEEF2",
      [habitRatingIndex]: "#EDEEF2",
      [currentStateIndex]: "#FFFFFF",
      [loveRelationshipIndex]: "#FFFFFF",
      [moneyFinanceIndex]: "#FFFFFF",
      [familyFriendsIndex]: "#FFFFFF",
      [careerBusinessIndex]: "#FFFFFF",
      [healthWellBeingIndex]: "#FFFFFF",
      [purposeMissionIndex]: "#FFFFFF",
      [environmentIndex]: "#FFFFFF",
      [saveResultsIndex]: "#EDEEF2",
      [QuizResultsIndex]: "#EDEEF2",
    }

    const backgroundColor = backgroundColorMap[currentIndex]

    const valuePropBulletPoints = [
      "Your personal Nervous System Dysregulation Score",
      "A detailed breakdown of your quiz results",
      "Tailored next steps to regulate your nervous system"
    ]

    const isMobile = innerWidth < MinDesktopWidthPixels

    return (
      <div style={{height: innerHeight}}>
        <Helmet
          title={"Dysregulated Nervous System Test | 2 Minutes | NEUROFIT App"}
          description={"Is your nervous system dysregulated? Get your personalized Nervous System Dysregulation Score & nervous system regulation tips."}
          href={ProductionQuizBaseUrl}
        />
        <div style={{position: "fixed", left: 0, top: 0, height: innerHeight, overflow: "hidden", backgroundColor: "#EDEEF2"}}>
          <div style={{position: "fixed", top: 0, left: 0, right: 0, height: safeAreaInsets.top, backgroundColor: "#000000", zIndex: 2000}} />
          <div style={{position: "fixed", top: 0, left: 0, right: 0, boxShadow: "0px 2px 0px 0px black", display: "flex", justifyContent: "space-between", alignItems: "center", paddingInlineStart: "min(40px, 7.5%)", paddingInlineEnd: 12, height: 60, backgroundColor: "white", zIndex: 1000}}>
            <NeuroFitNamedLogoLinkSvg
              logoSize={"min(4.25vw, 18px)"}
              color={"#000000"}
              href="/"
            />
          </div>
          <div style={{position: "fixed", top: safeAreaInsets.top + 62, insetInlineStart: 0, width: `${(completionPct * 100).toFixed(0)}%`, transition: "width 250ms ease-out", backgroundColor: "#000000", height: 5, zIndex: 1000}}>
          </div>
          <div 
            className={"disable-scrollbars"}
            style={{...containerStyle, backgroundColor, transition: "background-color 250ms linear"}}
          >
            <div style={{textAlign: "start", width: "100vw"}}>
              <div style={{color: "white", width: "100%", display: "flex", justifyContent: "center", alignItems: "top", height: innerHeight}}>
                <SwitchTransition mode="out-in">
                  <CSSTransition
                    timeout={400}
                    classNames={slideClassAnimation}
                    unmountOnExit
                    addEndListener={(node, done) => {
                      node.addEventListener("transitionend", done, false);
                    }}
                    key={currentIndex}
                  >
                    <div style={{maxWidth: 600, width: "85%", color: "#000", minHeight: `calc(${innerHeight - 60 - safeAreaInsets.top}px - 5vh)`, paddingTop: `calc(${60 + safeAreaInsets.top}px + 3vh)`}}>
                      {currentIndex === onboardingIndex && (
                        <div style={{color: "#000000", backgroundColor: "transparent",height: innerHeight, overflowY: "scroll", display: "flex", justifyContent: "center"}}>
                          <div style={{maxWidth: "100%", paddingBottom: "100px"}}>
                            <div style={{color: "#000000"}}>
                              <h1 style={{fontFamily: "Futura", textTransform: "uppercase", fontSize: "min(8vw, 40px)", textAlign: "start"}}>
                                {`Nervous System Regulation Quiz`}
                              </h1>
                              <h2 style={{marginTop: 20, fontSize: "min(6vw, 26px)", textAlign: "start", fontFamily: "Futura Light", fontWeight: "normal"}}>
                                <div style={{fontFamily: "Futura Book"}}>{"How balanced is your nervous system? Take the 2-minute quiz. You'll receive:"}</div>
                                <div style={{marginBottom: 10, marginTop: "min(24px, max(3vw, 16px))", backgroundColor: "rgba(255, 255, 255, 0.85)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", padding: "min(24px, max(3vw, 16px))", boxShadow: "0px 1px 1.5px 0.5px #dddddd"}}>
                                  {valuePropBulletPoints && valuePropBulletPoints.map(bulletPoint => (
                                    <MembershipFeatureDescription
                                      fontSize={"min(5vw, 22px)"}
                                      marginTop={"10px"}
                                      fontFamily={"Futura"}
                                      checkMarginTop={"0.25em"}
                                      text={bulletPoint}
                                      key={bulletPoint}
                                    />
                                  ))}
                                </div>
                              </h2>
                            </div>
                            <div style={{display: "flex", justifyContent: "center", marginTop: "5vh", pointerEvents: "none"}}>
                              <img src={isMobile ? "/images/media/media-logos-9-mobile-black.webp?v=0" : "/images/media/media-logos-9-desktop-black.webp?v=0"} fetchpriority="high" style={{width: "100%", maxWidth: 500, height: "calc(min(500px, 100%) / 2.9791)", opacity: 0.5}} alt="NEUROFIT has been featured in SHAPE, Well and Good, and Body and Soul." />
                            </div>
                            <div style={{display: "flex", width: "100%", justifyContent: "start", alignItems: "center", margin: "4vh 0px 4vh 0vh"}}>
                              <button
                                style={{display: "block", textTransform: "uppercase", width: "100%", fontFamily: "Futura", fontSize: "min(6vw, 25px)", color: "#FFFFFF", backgroundColor: "#000000", padding: "12px 15px", border: "none"}}
                                onClick={() => {
                                  this.setState({...this.state, scrollView: {...this.state.scrollView, slideClassAnimation: "next-story-slide-animation"}})
                                  setTimeout(() => {
                                    this.setState({...this.state, scrollView: {...this.state.scrollView, currentIndex: physicalSymptomsIndex}})
                                  }, 50)
                                  recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_ONBOARDING_SCREEN)
                                }}
                              >
                                {"Start The Quiz"}
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      {currentIndex === physicalSymptomsIndex && (
                        <div style={{padding: `0px 30px ${30 + safeAreaInsets.bottom}px 30px`, backgroundColor: "transparent"}}>
                          <div style={{fontSize: "min(7.5vw, 32px)", lineHeight: "min(7.5vw, 32px)", fontFamily: "Futura"}}>
                            {`I. PHYSICAL SIGNS`}
                          </div>
                          <RadioSection
                            title={"Gut Issues"}
                            subtitle={"I experience frequent gut or digestion problems."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.symptoms.digestive_problems}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, symptoms: {...quizResults.symptoms, digestive_problems: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.symptoms.digestive_problems !== null) && (updatedQuizResults.symptoms.persistent_pain !== null) && (updatedQuizResults.symptoms.frequent_sickness !== null) && (updatedQuizResults.symptoms.frequent_immune_issues !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: mentalSymptomsIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_DIGESTIVE_ISSUES_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Persistent Pain"}
                            subtitle={"I experience chronic or persistent aches and pains."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.symptoms.persistent_pain}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, symptoms: {...quizResults.symptoms, persistent_pain: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.symptoms.digestive_problems !== null) && (updatedQuizResults.symptoms.persistent_pain !== null) && (updatedQuizResults.symptoms.frequent_sickness !== null) && (updatedQuizResults.symptoms.frequent_immune_issues !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: mentalSymptomsIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_PERSISTENT_PAIN_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Frequent Illness"}
                            subtitle={"I frequently find myself getting sick."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.symptoms.frequent_sickness}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, symptoms: {...quizResults.symptoms, frequent_sickness: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.symptoms.digestive_problems !== null) && (updatedQuizResults.symptoms.persistent_pain !== null) && (updatedQuizResults.symptoms.frequent_sickness !== null) && (updatedQuizResults.symptoms.frequent_immune_issues !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: mentalSymptomsIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_FREQUENT_SICKNESS_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Frequent Immune Issues"}
                            subtitle={"I experience frequent infections or other immune system issues."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.symptoms.frequent_immune_issues}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, symptoms: {...quizResults.symptoms, frequent_immune_issues: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.symptoms.digestive_problems !== null) && (updatedQuizResults.symptoms.persistent_pain !== null) && (updatedQuizResults.symptoms.frequent_sickness !== null) && (updatedQuizResults.symptoms.frequent_immune_issues !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: mentalSymptomsIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_FREQUENT_IMMUNE_ISSUES_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                        </div>
                      )}
                      {currentIndex === mentalSymptomsIndex && (
                        <div style={{padding: `0px 30px ${30 + safeAreaInsets.bottom}px 30px`, backgroundColor: "transparent"}}>
                          <div style={{fontSize: "min(7.5vw, 32px)", lineHeight: "min(7.5vw, 32px)", fontFamily: "Futura"}}>
                            {`II. MENTAL SIGNS`}
                          </div>
                          <RadioSection
                            title={"Brain Fog"}
                            subtitle={"I often experience brain fog or have trouble concentrating."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.symptoms.brain_fog}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, symptoms: {...quizResults.symptoms, brain_fog: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.symptoms.brain_fog !== null) && (updatedQuizResults.symptoms.frequent_fatigue !== null) && (updatedQuizResults.symptoms.difficulty_relaxing !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: emotionalSymptomsIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_BRAIN_FOG_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Fatigue/Sleep Issues"}
                            subtitle={"I often have trouble falling asleep, even when I feel exhausted."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.symptoms.frequent_fatigue}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, symptoms: {...quizResults.symptoms, frequent_fatigue: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.symptoms.brain_fog !== null) && (updatedQuizResults.symptoms.frequent_fatigue !== null) && (updatedQuizResults.symptoms.difficulty_relaxing !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: emotionalSymptomsIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_FREQUENT_FATIGUE_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Relaxation Issues"}
                            subtitle={"I frequently feel on edge and struggle to relax or 'turn off'."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.symptoms.difficulty_relaxing}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, symptoms: {...quizResults.symptoms, difficulty_relaxing: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.symptoms.brain_fog !== null) && (updatedQuizResults.symptoms.frequent_fatigue !== null) && (updatedQuizResults.symptoms.difficulty_relaxing !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: emotionalSymptomsIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_DIFFICULTY_RELAXING_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                        </div>
                      )}
                      {currentIndex === emotionalSymptomsIndex && (
                        <div style={{padding: `0px 30px ${30 + safeAreaInsets.bottom}px 30px`, backgroundColor: "transparent"}}>
                          <div style={{fontSize: "min(7.5vw, 32px)", lineHeight: "min(7.5vw, 32px)", fontFamily: "Futura"}}>
                            {`III. EMOTIONAL SIGNS`}
                          </div>
                          <RadioSection
                            title={"Difficulty Balancing Emotions"}
                            subtitle={"I often experience difficulty staying balanced when expressing my emotions."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.symptoms.difficulty_controlling_emotions}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, symptoms: {...quizResults.symptoms, difficulty_controlling_emotions: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.symptoms.difficulty_controlling_emotions !== null) && (updatedQuizResults.symptoms.frequent_anxiety_stress !== null) && (updatedQuizResults.symptoms.frequently_irritable_on_edge !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: activityCheckBoxIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_DIFFICULTY_CONTROLLING_EMOTIONS_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Frequent Anxiety"}
                            subtitle={"I often experience anxiety or stress, which at times feels overwhelming."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.symptoms.frequent_anxiety_stress}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, symptoms: {...quizResults.symptoms, frequent_anxiety_stress: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.symptoms.difficulty_controlling_emotions !== null) && (updatedQuizResults.symptoms.frequent_anxiety_stress !== null) && (updatedQuizResults.symptoms.frequently_irritable_on_edge !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: activityCheckBoxIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_FREQUENT_ANXIETY_STRESS_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Frequent Irritability"}
                            subtitle={"I often feel noticeably irritable, or as if I am constantly on edge."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.symptoms.frequently_irritable_on_edge}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, symptoms: {...quizResults.symptoms, frequently_irritable_on_edge: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.symptoms.difficulty_controlling_emotions !== null) && (updatedQuizResults.symptoms.frequent_anxiety_stress !== null) && (updatedQuizResults.symptoms.frequently_irritable_on_edge !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: activityCheckBoxIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_FREQUENTLY_IRRITABLE_ON_EDGE_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                        </div>
                      )}
                      {currentIndex === activityCheckBoxIndex && (
                        <div style={{padding: `0px 30px ${30 + safeAreaInsets.bottom}px 30px`, backgroundColor: "transparent"}}>
                          <div style={{fontSize: "min(7.5vw, 32px)", lineHeight: "min(7.5vw, 32px)", fontFamily: "Futura"}}>
                            {`IV. EMBODY HABITS`}
                          </div>
                          <RadioSection
                            title={"Exercise"}
                            subtitle={"Most days, I exercise for 10+ minutes."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.daily_habits.exercise_10_min}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, daily_habits: {...quizResults.daily_habits, exercise_10_min: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.daily_habits.exercise_10_min !== null) && (updatedQuizResults.daily_habits.play_creativity_10_min !== null) && (updatedQuizResults.daily_habits.stillness_10_min !== null) && (updatedQuizResults.daily_habits.bedtime_routine !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: activityCheckBox2Index, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_EXERCISE_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Social Play"}
                            subtitle={"Most days, I play with others face-to-face for 10+ minutes."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.daily_habits.play_creativity_10_min}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, daily_habits: {...quizResults.daily_habits, play_creativity_10_min: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.daily_habits.exercise_10_min !== null) && (updatedQuizResults.daily_habits.play_creativity_10_min !== null) && (updatedQuizResults.daily_habits.stillness_10_min !== null) && (updatedQuizResults.daily_habits.bedtime_routine !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: activityCheckBox2Index, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_PLAY_CREATIVITY_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Stillness"}
                            subtitle={"Most days, I practice stillness for 10+ minutes (eg meditation)."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.daily_habits.stillness_10_min}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, daily_habits: {...quizResults.daily_habits, stillness_10_min: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.daily_habits.exercise_10_min !== null) && (updatedQuizResults.daily_habits.play_creativity_10_min !== null) && (updatedQuizResults.daily_habits.stillness_10_min !== null) && (updatedQuizResults.daily_habits.bedtime_routine !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: activityCheckBox2Index, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_STILLNESS_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Sleep-Wake Cycle"}
                            subtitle={"Most days, I get early morning sunlight and go to sleep at my usual bedtime."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.daily_habits.bedtime_routine}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, daily_habits: {...quizResults.daily_habits, bedtime_routine: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.daily_habits.exercise_10_min !== null) && (updatedQuizResults.daily_habits.play_creativity_10_min !== null) && (updatedQuizResults.daily_habits.stillness_10_min !== null) && (updatedQuizResults.daily_habits.bedtime_routine !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: activityCheckBox2Index, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_BEDTIME_ROUTINE_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                        </div>
                      )}
                      {currentIndex === activityCheckBox2Index && (
                        <div style={{padding: `0px 30px ${30 + safeAreaInsets.bottom}px 30px`, backgroundColor: "transparent"}}>
                          <div style={{fontSize: "min(7.5vw, 32px)", lineHeight: "min(7.5vw, 32px)", fontFamily: "Futura"}}>
                            {`V. PREVENT HABITS`}
                          </div>
                          <RadioSection
                            title={"Late-Night Eating"}
                            subtitle={"Most days, I avoid eating within 3 hours of bedtime."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.daily_habits.avoided_late_night_eating}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, daily_habits: {...quizResults.daily_habits, avoided_late_night_eating: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.daily_habits.avoided_late_night_eating !== null) && (updatedQuizResults.daily_habits.avoided_alcohol_and_substances !== null) && (updatedQuizResults.daily_habits.avoided_stressful_online_content !== null) && (updatedQuizResults.daily_habits.avoided_social_fatigue !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: habitRatingIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_AVOID_LATE_NIGHT_EATING_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Alcohol & Substances"}
                            subtitle={"Most days, I avoid alcohol+substances."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.daily_habits.avoided_alcohol_and_substances}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, daily_habits: {...quizResults.daily_habits, avoided_alcohol_and_substances: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.daily_habits.avoided_late_night_eating !== null) && (updatedQuizResults.daily_habits.avoided_alcohol_and_substances !== null) && (updatedQuizResults.daily_habits.avoided_stressful_online_content !== null) && (updatedQuizResults.daily_habits.avoided_social_fatigue !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: habitRatingIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_AVOID_ALCOHOL_SUBSTANCES_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Online Content"}
                            subtitle={"Most days, I avoid stressful content on apps and the internet."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.daily_habits.avoided_stressful_online_content}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, daily_habits: {...quizResults.daily_habits, avoided_stressful_online_content: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.daily_habits.avoided_late_night_eating !== null) && (updatedQuizResults.daily_habits.avoided_alcohol_and_substances !== null) && (updatedQuizResults.daily_habits.avoided_stressful_online_content !== null) && (updatedQuizResults.daily_habits.avoided_social_fatigue !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: habitRatingIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_AVOID_STRESSFUL_ONLINE_CONTENT_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                          <RadioSection
                            title={"Social Fatigue"}
                            subtitle={"Most days, I avoid social interactions that feel frustrating and draining."}
                            label1={"Yes"}
                            label2={"No"}
                            selectedOption={quizResults.daily_habits.avoided_social_fatigue}
                            option1={true}
                            option2={false}
                            onSelect={(val) => {
                              const updatedQuizResults = {...quizResults, daily_habits: {...quizResults.daily_habits, avoided_social_fatigue: val}}
                              this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                              if ((updatedQuizResults.daily_habits.avoided_late_night_eating !== null) && (updatedQuizResults.daily_habits.avoided_alcohol_and_substances !== null) && (updatedQuizResults.daily_habits.avoided_stressful_online_content !== null) && (updatedQuizResults.daily_habits.avoided_social_fatigue !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: habitRatingIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_AVOID_SOCIAL_FATIGUE_CHECKBOX)
                            }}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                            color={"#000000"}
                          />
                        </div>
                      )}
                      {currentIndex === habitRatingIndex && (
                        <div style={{padding: `0px 30px ${30 + safeAreaInsets.bottom}px 30px`, width: "80vw", maxWidth: 500, backgroundColor: "transparent"}}>
                          <div style={{fontSize: "min(7.5vw, 32px)", lineHeight: "min(7.5vw, 32px)", fontFamily: "Futura"}}>
                            {`VI. SELF-CARE HABITS`}
                          </div>
                          <SliderSection
                            title={`SLEEP`}
                            subtitle={"Rate your sleep quality as of late."}
                            disableRtl
                            value={quizResults.daily_habits.sleep}
                            onChange={(val) => this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: {...quizResults, daily_habits: {...quizResults.daily_habits, sleep: val}}})}
                            onAfterChange={val => {
                              if ((val !== null) && (quizResults.daily_habits.diet !== null) && (quizResults.daily_habits.water !== null) && (quizResults.daily_habits.peace !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: currentStateIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: {...quizResults, daily_habits: {...quizResults.daily_habits, sleep: val}}})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_RATE_SLEEP_QUALITY_SLIDER)
                            }}
                            min={0}
                            max={10}
                            isDisabled={formFieldsDisabled}
                            marginTop={"4vh"}
                          />
                          <SliderSection
                            title={`DIET`}
                            subtitle={"Rate your diet quality as of late."}
                            disableRtl
                            value={quizResults.daily_habits.diet}
                            onChange={(val) => this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: {...quizResults, daily_habits: {...quizResults.daily_habits, diet: val}}})}
                            onAfterChange={val => {
                              if ((val !== null) && (quizResults.daily_habits.sleep !== null) && (quizResults.daily_habits.water !== null) && (quizResults.daily_habits.peace !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: currentStateIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: {...quizResults, daily_habits: {...quizResults.daily_habits, diet: val}}})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_RATE_DIET_QUALITY_SLIDER)
                            }}
                            min={0}
                            max={10}
                            isDisabled={formFieldsDisabled}
                            marginTop={"3vh"}
                          />
                          <SliderSection
                            title={`WATER`}
                            subtitle={"Rate your water intake as of late."}
                            disableRtl
                            value={quizResults.daily_habits.water}
                            onChange={(val) => this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: {...quizResults, daily_habits: {...quizResults.daily_habits, water: val}}})}
                            onAfterChange={val => {
                              if ((val !== null) && (quizResults.daily_habits.sleep !== null) && (quizResults.daily_habits.diet !== null) && (quizResults.daily_habits.peace !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: currentStateIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: {...quizResults, daily_habits: {...quizResults.daily_habits, water: val}}})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_RATE_WATER_INTAKE_QUALITY_SLIDER)
                            }}
                            min={0}
                            max={10}
                            isDisabled={formFieldsDisabled}
                            marginTop={"3vh"}
                          />
                          <SliderSection
                            title={`PEACE`}
                            subtitle={"Rate your overall peace as of late."}
                            disableRtl
                            value={quizResults.daily_habits.peace}
                            onChange={(val) => this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: {...quizResults, daily_habits: {...quizResults.daily_habits, peace: val}}})}
                            onAfterChange={val => {
                              if ((val !== null) && (quizResults.daily_habits.sleep !== null) && (quizResults.daily_habits.diet !== null) && (quizResults.daily_habits.water !== null)) {
                                setTimeout(() => {
                                  this.setState({scrollView: {currentIndex: currentStateIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: {...quizResults, daily_habits: {...quizResults.daily_habits, peace: val}}})
                                }, 300)
                              }
                              recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_RATE_OVERALL_PEACE_QUALITY_SLIDER)
                            }}
                            min={0}
                            max={10}
                            isDisabled={formFieldsDisabled}
                            marginTop={"3vh"}
                          />
                        </div>
                      )}
                      {currentIndex === currentStateIndex && (
                        <NeuroFitRing
                          title={"VII. Tap your current state."}
                          marginTop={"0px"}
                          paddingBottom={30 + safeAreaInsets.bottom}
                          onRingClick={val => {
                            const updatedQuizResults = {...quizResults, self: {current_mood: val}}
                            this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            setTimeout(() => {
                              this.setState({scrollView: {currentIndex: loveRelationshipIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            }, 300)
                            recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_CURRENT_STATE_SCREEN)
                          }}
                          currentState={quizResults.self.current_mood}
                          ringContainerBackgroundColor={"#FFFFFF"}
                          ringInitialBackgroundColor={"#EDEEF2"}
                        />
                      )}
                      {currentIndex === loveRelationshipIndex && (
                        <NeuroFitRing
                          title={"VIII. Map each life aspect as of late."}
                          marginTop={"0px"}
                          paddingBottom={30 + safeAreaInsets.bottom}
                          subTitle={"LOVE & RELATIONSHIP"}
                          onRingClick={val => {
                            const updatedQuizResults = {...quizResults, life_aspects: {...quizResults.life_aspects, love_and_relationship: val}}
                            this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            setTimeout(() => {
                              this.setState({scrollView: {currentIndex: moneyFinanceIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            }, 300)
                            recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_LOVE_AND_RELATIONSHIP_SCREEN)
                          }}
                          currentState={quizResults.life_aspects.love_and_relationship}
                          ringContainerBackgroundColor={"#FFFFFF"}
                          ringInitialBackgroundColor={"#EDEEF2"}
                        />
                      )}
                      {currentIndex === moneyFinanceIndex && (
                        <NeuroFitRing
                          title={"VIII. Map each life aspect as of late."}
                          marginTop={"0px"}
                          paddingBottom={30 + safeAreaInsets.bottom}
                          subTitle={"MONEY & FINANCE"}
                          onRingClick={val => {
                            const updatedQuizResults = {...quizResults, life_aspects: {...quizResults.life_aspects, money_and_finance: val}}
                            this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            setTimeout(() => {
                              this.setState({scrollView: {currentIndex: familyFriendsIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            }, 300)
                            recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_MONEY_AND_FINANCE_SCREEN)
                          }}
                          currentState={quizResults.life_aspects.money_and_finance}
                          ringContainerBackgroundColor={"#FFFFFF"}
                          ringInitialBackgroundColor={"#EDEEF2"}
                        />
                      )}
                      {currentIndex === familyFriendsIndex && (
                        <NeuroFitRing
                          title={"VIII. Map each life aspect as of late."}
                          marginTop={"0px"}
                          paddingBottom={30 + safeAreaInsets.bottom}
                          subTitle={"FAMILY & FRIENDS"}
                          onRingClick={val => {
                            const updatedQuizResults = {...quizResults, life_aspects: {...quizResults.life_aspects, family_and_friends: val}}
                            this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            setTimeout(() => {
                              this.setState({scrollView: {currentIndex: careerBusinessIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            }, 300)
                            recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_FAMILY_AND_FRIENDS_SCREEN)
                          }}
                          currentState={quizResults.life_aspects.family_and_friends}
                          ringContainerBackgroundColor={"#FFFFFF"}
                          ringInitialBackgroundColor={"#EDEEF2"}
                        />
                      )}
                      {currentIndex === careerBusinessIndex && (
                        <NeuroFitRing
                          title={"VIII. Map each life aspect as of late."}
                          marginTop={"0px"}
                          paddingBottom={30 + safeAreaInsets.bottom}
                          subTitle={"CAREER & BUSINESS"}
                          onRingClick={val => {
                            const updatedQuizResults = {...quizResults, life_aspects: {...quizResults.life_aspects, career_and_business: val}}
                            this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            setTimeout(() => {
                              this.setState({scrollView: {currentIndex: healthWellBeingIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            }, 300)
                            recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_CAREER_AND_BUSINESS_SCREEN)
                          }}
                          currentState={quizResults.life_aspects.career_and_business}
                          ringContainerBackgroundColor={"#FFFFFF"}
                          ringInitialBackgroundColor={"#EDEEF2"}
                        />
                      )}
                      {currentIndex === healthWellBeingIndex && (
                        <NeuroFitRing
                          title={"VIII. Map each life aspect as of late."}
                          marginTop={"0px"}
                          paddingBottom={30 + safeAreaInsets.bottom}
                          subTitle={"HEALTH & WELL-BEING"}
                          onRingClick={val => {
                            const updatedQuizResults = {...quizResults, life_aspects: {...quizResults.life_aspects, health_and_well_being: val}}
                            this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            setTimeout(() => {
                              this.setState({scrollView: {currentIndex: purposeMissionIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            }, 300)
                            recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_HEALTH_AND_WELL_BEING_SCREEN)
                          }}
                          currentState={quizResults.life_aspects.health_and_well_being}
                          ringContainerBackgroundColor={"#FFFFFF"}
                          ringInitialBackgroundColor={"#EDEEF2"}
                        />
                      )}
                      {currentIndex === purposeMissionIndex && (
                        <NeuroFitRing
                          title={"VIII. Map each life aspect as of late."}
                          marginTop={"0px"}
                          paddingBottom={30 + safeAreaInsets.bottom}
                          subTitle={"PURPOSE & MISSION"}
                          onRingClick={val => {
                            const updatedQuizResults = {...quizResults, life_aspects: {...quizResults.life_aspects, purpose_and_mission: val}}
                            this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            setTimeout(() => {
                              this.setState({scrollView: {currentIndex: environmentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            }, 300)
                            recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_PURPOSE_AND_MISSION_SCREEN)
                          }}
                          currentState={quizResults.life_aspects.purpose_and_mission}
                          ringContainerBackgroundColor={"#FFFFFF"}
                          ringInitialBackgroundColor={"#EDEEF2"}
                        />
                      )}
                      {currentIndex === environmentIndex && (
                        <NeuroFitRing
                          title={"VIII. Map each life aspect as of late."}
                          marginTop={"0px"}
                          paddingBottom={30 + safeAreaInsets.bottom}
                          subTitle={"ENVIRONMENT"}
                          onRingClick={val => {
                            const updatedQuizResults = {...quizResults, life_aspects: {...quizResults.life_aspects, environment: val}}
                            this.setState({scrollView: {currentIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            setTimeout(() => {
                              this.setState({scrollView: {currentIndex: saveResultsIndex, slideClassAnimation: "next-story-slide-animation"}, quizResults: updatedQuizResults})
                            }, 300)
                            recordFunnelEventGA(GA_LABEL_QUIZ_COMPLETED_ENVIRONMENT_SCREEN)
                          }}
                          currentState={quizResults.life_aspects.environment}
                          ringContainerBackgroundColor={"#FFFFFF"}
                          ringInitialBackgroundColor={"#EDEEF2"}
                        />
                      )}
                      {currentIndex === saveResultsIndex && (
                        <div style={{color: "white", width: "100%", display: "flex", justifyContent: "center", alignItems: "top"}}>
                          <div style={{width: "85%", maxWidth: 600, color: "#000"}}>
                            <div style={{backgroundColor: "#EDEEF2", padding: "min(24px, max(3vw, 16px))", marginTop: "max(6vw, 32px)"}}>
                              <div style={{display: "block", fontFamily: "Futura", fontSize: "min(6vw, 26px)", marginBottom: "min(24px, max(3vw, 16px))", lineHeight: "min(5vw, 22px)"}}>
                                {"IX. FINALIZE RESULTS"}
                              </div>
                              <div style={{marginInlineEnd: "0.2em", fontSize: "min(5vw, 20px)", fontFamily: "Futura Light"}}>
                                {"Enter your name and email address, and we'll send a copy of your quiz results to your inbox."}
                              </div>
                              {isCoachingLink && (
                                <div style={{marginInlineEnd: "0.2em", marginTop: "2vh", marginBottom: "max(0.75vw, 4px)", fontSize: "min(5vw, 20px)", fontFamily: "Futura Light"}}>
                                  {"Your Coach will respond to your quiz results in 1-2 business days."}
                                </div>
                              )}
                              <div style={{marginTop: "2vh"}}>
                                <input
                                  type="text"
                                  value={quizResults.contact_details.first_name || ""}
                                  disabled={formFieldsDisabled}
                                  autoCapitalize="true"
                                  autoCorrect="false"
                                  autoComplete="off"
                                  spellCheck={false}
                                  onChange={(e) => {
                                    if (e.target.value !== "" && quizResults.contact_details.first_name === null) {
                                      recordFunnelEventGA(GA_LABEL_QUIZ_ENTERED_FIRST_NAME)
                                    }
                                    const updatedQuizResults = {...quizResults, contact_details: {...quizResults.contact_details, first_name: e.target.value}}
                                    this.setState({...this.state, quizResults: updatedQuizResults})
                                  }}
                                  onPaste={(e) => {
                                    if (e.target.value !== "" && quizResults.contact_details.first_name === null) {
                                      recordFunnelEventGA(GA_LABEL_QUIZ_ENTERED_FIRST_NAME)
                                    }
                                    const updatedQuizResults = {...quizResults, contact_details: {...quizResults.contact_details, first_name: e.target.value}}
                                    this.setState({...this.state, quizResults: updatedQuizResults})
                                  }}
                                  placeholder={"First Name"}
                                  className={"application-input"}
                                />
                              </div>
                              <div style={{marginTop: 16, marginBottom: "2vh"}}>
                                <input
                                  type="text"
                                  value={quizResults.contact_details.email_address || ""}
                                  disabled={formFieldsDisabled}
                                  autoCapitalize="none"
                                  autoCorrect="false"
                                  autoComplete="off"
                                  spellCheck={false}
                                  onChange={(e) => {
                                    if (e.target.value !== "" && quizResults.contact_details.email_address === null) {
                                      recordFunnelEventGA(GA_LABEL_QUIZ_ENTERED_EMAIL_ADDRESS)
                                    }
                                    const updatedQuizResults = {...quizResults, contact_details: {...quizResults.contact_details, email_address: e.target.value.toLowerCase()}}
                                    this.setState({...this.state, quizResults: updatedQuizResults})
                                  }}
                                  onPaste={(e) => {
                                    if (e.target.value !== "" && quizResults.contact_details.email_address === null) {
                                      recordFunnelEventGA(GA_LABEL_QUIZ_ENTERED_EMAIL_ADDRESS)
                                    }
                                    const updatedQuizResults = {...quizResults, contact_details: {...quizResults.contact_details, email_address: e.target.value.toLowerCase()}}
                                    this.setState({...this.state, quizResults: updatedQuizResults})
                                  }}
                                  placeholder={"Email Address"}
                                  className={"application-input"}
                                />
                              </div>
                              <SendRequestButton
                                defaultContent={"SAVE & VIEW RESULTS"}
                                loadingText={"SAVING RESULTS..."}
                                successText={"RESULTS SAVED"}
                                requestState={createQuizResultState}
                                isDisabled={!saveButtonEnabled}
                                onClick={() => {
                                  onCreateQuizResults(quizResults)
                                  recordFunnelEventGA(GA_LABEL_QUIZ_TRIGGERED_SAVE_RESULTS)
                                }}
                              />
                              <div style={{fontSize: "min(4vw, 18px)", color: "#999999", marginTop: "4vh"}}>
                                <span style={{marginInlineEnd: "0.2em"}}>{"By submitting your quiz results, you agree to our"}</span>
                                <a style={{color: "#999999", fontFamily: "Futura"}} href={`${subdomainUrls.baseLegalUrl}/#terms`} target="_blank" rel="noopener noreferrer nofollow">{"Terms"}</a>
                                <span style={{marginInlineEnd: "0.2em"}}>{" & "}</span>
                                <a style={{color: "#999999", fontFamily: "Futura"}} href={`${subdomainUrls.baseLegalUrl}/#privacy`} target="_blank" rel="noopener noreferrer nofollow">{"Privacy Policy"}</a>
                                <span>{". Thank you!"}</span>
                              </div>
                            </div>
                            <div style={{marginTop: "max(6vw, 32px)", marginBottom: `calc(max(6vw, 32px) + ${safeAreaInsets.bottom}px)`, display: "flex", justifyContent: "center"}}>
                              <NeuroFitNamedLogoSvg
                                logoSize={"min(4.25vw, 18px)"}
                                color={"#CFD2DD"}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {currentIndex === QuizResultsIndex && (
                        <DysregulationQuizResults
                          safeAreaInsets={safeAreaInsets}
                          quizResultState={createQuizResultState}
                          quizResults={(createQuizResultState === REQUEST_SUCCESS) && createQuizResult}
                          isIOSDevice={isIOSDevice}
                          isAndroidDevice={isAndroidDevice}
                          logAnalytics
                        />
                      )}
                    </div>
                  </CSSTransition>
                </SwitchTransition>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DysregulationQuizPage;